import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ChatComponent } from './chat.component';
import { AuthGuard } from '../shared/auth.guard';

const routes: Routes = [];

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'chat', component: ChatComponent, canActivate: [AuthGuard] }
    ])
  ],
  exports: [RouterModule]
})
export class ChatRoutingModule {}
